// extracted by mini-css-extract-plugin
export default {"list":"Section_list__-k2Jq"};